module.exports = "/assets/data/1e4209b11b82a87ffc44ed9a62c9fe1e-BS41.data.json";